<template>
  <gv-modal :size="isMobile ? 'sm' : 'lg'" :modal="modal" @close="onClose">
    <template #header> <div></div> </template>
    <template #default>
      <ui-event-summary :event="relatedEvent" :hazard="selectedHazard as SelectedHazard" @close="onClose" />
    </template>
    <template #footer>
      <div class="px-4 pb-6">
        <ui-map-popup-footer left-text="Show map" :show-top-border="false" right-text="" :left-callback="showMap" />
      </div>
    </template>
  </gv-modal>
</template>

<script setup lang="ts">
import { UseModal, isMobile } from '@/common';
import gvModal from '@/common/components/gvModal/gvModal.vue';
import { EventEntity, HazardType, HazardView, SelectedHazard, SelectedHazardViewType, useHazardsStore } from '@/features/hazards';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';

const props = defineProps<{
  modal: UseModal;
}>();

const closeByRedirect = ref(false);
const hazardsStore = useHazardsStore();
const { selectedHazard, hazards } = storeToRefs(hazardsStore);

const relatedEvent = computed<EventEntity | undefined>(() => {
  return hazards.value.events.find((event) => event.id === selectedHazard.value?.eventId);
});

const showMap = () => {
  const { hazardId, hazardType, eventId } = selectedHazard.value ?? {};

  closeByRedirect.value = true;
  props.modal.setClosed();

  if (hazardsStore.activeView === HazardView.List) {
    hazardsStore.setActiveView(HazardView.Both);
  }

  if (hazardId && hazardType) {
    hazardsStore.toggleSelectHazard({ hazardId, hazardType, eventId: eventId ?? '', viewType: SelectedHazardViewType.Popup });
  }
};

const onClose = () => {
  props.modal.setClosed();
  if (!closeByRedirect.value) hazardsStore.toggleSelectHazard(null);
  closeByRedirect.value = false;
};

watch(
  selectedHazard,
  (newSelectedHazard) => {
    if (
      newSelectedHazard &&
      newSelectedHazard.viewType === SelectedHazardViewType.Modal &&
      newSelectedHazard.hazardType !== HazardType.FireDangerRating
    ) {
      props.modal.setOpen();
    } else {
      props.modal.setClosed();
    }
  },
  { immediate: true }
);
</script>
